import React from "react";
import { Box, Divider, Typography, IconButton, Tooltip } from "@mui/material";
import { ContentCopy as ContentCopyIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";

function PageBreak({ index, handleDeleteQuestion, handleDuplicateQuestion }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #1976d2",
        borderRadius: "8px",
        p: 1,
      }}
    >
      <Divider sx={{ flexGrow: 1 }} />
      <Typography variant="body2" sx={{ mx: 2, color: "text.secondary" }}>
        <FormattedMessage id="survey.page_break.label" />
      </Typography>
      <Divider sx={{ flexGrow: 1 }} />
      <Box>
        <Tooltip title={<FormattedMessage id="survey.page_break.duplicate_tooltip" />}>
          <IconButton onClick={() => handleDuplicateQuestion(index)}>
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title={<FormattedMessage id="survey.page_break.delete_tooltip" />}>
          <IconButton onClick={() => handleDeleteQuestion(index)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

export default PageBreak;
